<div class="Vert-30"></div>

<div class="company-footer row">



    <div class="col-xl-12 text-center">

        <div class="row">
            <div class="col-xl-4 col-lg-12 logo">
                <a class="logo" href="https://crosscountrymortgage.com/" target="_blank"><img type="image/png"
                        src="/assets/images/logos/CCM-logo-std.png" /></a><br />
            </div>
            <div class="col-xl-4">&nbsp;</div>
            <div class="col-xl-4 col-lg-12">
                <ul class="menu">
                    <li>
                        <a title="Follow CrossCountry Mortgage on Facebook"
                            href="https://www.facebook.com/crosscountrymrtg/" target="_blank">
                            <fa-icon [icon]="['fab','facebook']"></fa-icon>
                        </a>
                    </li>
                    <li>
                        <a title="Follow CrossCountry Mortgage on LinkedIn"
                            href="https://www.linkedin.com/company/crosscountry-mortgage" target="_blank">
                            <fa-icon [icon]="['fab','linkedin']"></fa-icon>
                        </a>
                    </li>
                    <li>
                        <a title="Follow CrossCountry Mortgage on Twitter" href="https://twitter.com/crosscountrymtg"
                            target="_blank">
                            <fa-icon [icon]="['fab','x-twitter']"></fa-icon>
                        </a>
                    </li>
                    <li>
                        <a title="Follow CrossCountry Mortgage on Instagram"
                            href="https://www.instagram.com/crosscountrymtg/" target="_blank">
                            <fa-icon [icon]="['fab','instagram']"></fa-icon>
                        </a>
                    </li>
                    <li>
                        <a title="Follow CrossCountry Mortgage on Youtube"
                            href="https://www.youtube.com/channel/UCgguInv4WdSiYXipWyYFLYw" target="_blank">
                            <fa-icon [icon]="['fab','youtube']"></fa-icon>
                        </a>
                    </li>
                    <li>
                        <a title="View CrossCountry Mortgage on Zillow"
                            href="https://www.zillow.com/lender-profile/CrossCountryMortgageLLC" target="_blank">
                            <svg class="icon" role="img" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                                <rect width="100%" height="100%" fill="black"></rect>
                                <title>Zillow</title>
                                <path
                                    d="M12.006 0L1.086 8.627v3.868c3.386-2.013 11.219-5.13 14.763-6.015.11-.024.16.005.227.078.372.427 1.586 1.899 1.916 2.301a.128.128 0 0 1-.03.195 43.607 43.607 0 0 0-6.67 6.527c-.03.037-.006.043.012.03 2.642-1.134 8.828-2.94 11.622-3.452V8.627zm-.48 11.177c-2.136.708-8.195 3.307-10.452 4.576V24h21.852v-7.936c-2.99.506-11.902 3.16-15.959 5.246a.183.183 0 0 1-.23-.036l-2.044-2.429c-.055-.061-.062-.098.011-.208 1.574-2.3 4.789-5.899 6.833-7.418.042-.03.031-.06-.012-.042Z"
                                    fill="white"></path>
                            </svg>
                        </a>
                    </li>
                </ul>
            </div>
        </div>

        <div class="Vert-30"></div>

        <div class="row">
            <div class="col-12" style="padding-left:25px;">
                CrossCountry Mortgage, LLC<br />
                2160 Superior Avenue, Cleveland, Ohio 44114<br />
                <div class="Vert-20"></div>
            </div>


            <!--Large Mode-->
            <div class="col-xl-4 d-none d-md-block" style="padding-left:25px;">
                <div>© <lgv-current-year></lgv-current-year> CrossCountry Mortgage, LLC. | NMLS 3029</div>
            </div>
            <!--Mobile-->
            <div class="col-xl-4 d-md-none" style="padding-left:25px;">
                <div>© <lgv-current-year></lgv-current-year> CrossCountry Mortgage, LLC.</div>
                <div>NMLS 3029</div>
            </div>

            <div class="col-xl-8">
                <ul class="menu">
                    <li>
                        <img alt="Equal Housing Opportunity" src="/assets/images/icons/eho.png" height="37" style="margin-top:-10px;">
                    </li>
                    <li>
                        <a href="http://nmlsconsumeraccess.org/" target="_blank">NMLS Consumer Access</a>
                    </li>
                    <li>
                        <a href="https://crosscountrymortgage.com/privacy-policy/" target="_blank">Privacy Statement</a>
                    </li>
                    <li>
                        <a href="https://crosscountrymortgage.com/terms-and-conditions/" target="_blank">Terms and Conditions</a>
                    </li>
                    <li>
                        <a href="https://crosscountrymortgage.com/licensing-and-disclosures/" target="_blank">Disclosures & Licensing</a>
                    </li>
                </ul>
            </div>
        </div>
    </div>



</div>
<div class="Vert-30"></div>
